<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useGtm } from '@/hooks/useGtm'
export default defineComponent({
  name: 'BridgeChildRender',
  props: {
    item: {
      type: Object,
      default: () => ({} as AnyObject),
    },
    index: {
      type: Number,
      default: () => 1,
    },
    currentBridge: {
      type: String,
      default: '',
    },
  },
  emits: ['setBridge'],
  setup(_, { emit }) {
    const { pushGtm } = useGtm()
    const bridgeRef = ref(null)
    const setBridge = (item) => {
      emit('setBridge', item)
      pushGtm(bridgeRef.value)
    }
    return {
      bridgeRef,
      setBridge,
    }
  },
})
</script>

<template>
  <div
    ref="bridgeRef"
    class="col-6 cursor-pointer"
    :glasson-click="`bridge_${index + 1}_button`"
    @click="setBridge(item.value)"
  >
    <q-card
      v-ripple
      class="rounded-borders relative-position" :class="[
        { border: currentBridge === item.value },
      ]"
    >
      <q-img
        style="height: 135px"
        :src="item.photo"
        alt="image cover"
        no-spinner
        no-transition
        fetchpriority="high"
      >
        <div
          v-if="currentBridge === item.value"
          class="absolute-top-right bg-transparent"
          style="padding: 2px 4px"
        >
          <q-avatar
            class="shadow-3"
            color="secondary"
            text-color="white"
            size="sm"
          >
            <q-icon name="checked" size="16px" />
          </q-avatar>
        </div>
      </q-img>
    </q-card>
  </div>
</template>
